import $ from 'jquery';
import EventsHelper from '../../../_helpers/events';

export default class MatchHeader {

  $MatchHeader = {};
  isFirstLoad = true;
  data = {};
  statusClasses = {
    '0': 'vbw-mu-scheduled',
    '1': 'vbw-mu-live',
    '2': 'vbw-mu-finished'
  };

  matchStatus = {
    DEFAULT: -1,
    SCHEDULED: 0,
    LIVE: 1,
    FINISHED: 2,
  };


  constructor() {

    let _this = this;

    _this.$MatchHeader = $('.vbw-match-header');

    EventsHelper.On('MatchDataUpdate', function (data) {

      if (data.detail) {
        _this.data = data.detail;
        _this.updateScores();
        _this.updateSets();
        _this.updateStatus();
      }

      if (_this.isFirstLoad) {
        _this.$MatchHeader.find('.vbw-mu__score').removeClass('hidden');
        _this.$MatchHeader.find('.vbw-mu__sets').removeClass('hidden');
        _this.isFirstLoad = false;
      }


    });
  }

  updateScores() {
    let _this = this;

    let pointsA = (_this.data.status != _this.matchStatus.FINISHED) ? _this.data.currentSetTeamAPoints : _this.data.matchPointsA;
    let pointsB = (_this.data.status != _this.matchStatus.FINISHED) ? _this.data.currentSetTeamBPoints : _this.data.matchPointsB;

    _this.$MatchHeader.find('.vbw-mu__score--home').text(pointsA);
    _this.$MatchHeader.find('.vbw-mu__score--away').text(pointsB);

    _this.$MatchHeader.find('.vbw-mu__score--away').removeClass('winner');
    _this.$MatchHeader.find('.vbw-mu__score--home').removeClass('winner');

    if (pointsA > pointsB) {
      _this.$MatchHeader.find('.vbw-mu__score--home').addClass('winner');
    } else if (pointsA < pointsB) {
      _this.$MatchHeader.find('.vbw-mu__score--away').addClass('winner');
    }
  }

  updateSets() {
    let _this = this;
    let currentSet = _this.data.currentSetNo;
    let $setsList = _this.$MatchHeader.find('.vbw-mu__sets--result');

    $setsList.each(function () {
      let setItem = $(this);
      let setNo = setItem.data('set-no');

      let setData = _this.data.sets[setNo];

      if (currentSet <= setNo || setData.no === 0) {
        setItem.addClass('hidden');
      }
      else {
        setItem.removeClass('hidden');
      }

      if (setData) {
        setItem.find('.vbw-mu__pointA').text(setData.pointsTeamA);
        setItem.find('.vbw-mu__pointB').text(setData.pointsTeamB);

        setItem.find('.vbw-mu__pointB').removeClass('winner');
        setItem.find('.vbw-mu__pointA').removeClass('winner');

        if (setData.pointsTeamA > setData.pointsTeamB) {

          setItem.find('.vbw-mu__pointA').addClass('winner');

        } else if (setData.pointsTeamA < setData.pointsTeamB) {

          setItem.find('.vbw-mu__pointB').addClass('winner');

        }

      }

    });
  }

  setStatusClass($el) {

    let _this = this;

    $el.removeClass('vbw-mu-scheduled');
    $el.removeClass('vbw-mu-live');
    $el.removeClass('vbw-mu-finished');

    $el.addClass(_this.statusClasses[_this.data.status]);

  }

  updateStatus() {
    let _this = this;
    let $innerMatch = _this.$MatchHeader.find('.vbw-mu--match');
    _this.setStatusClass($innerMatch);

    _this.$MatchHeader.find('.vbw-mu__status .vbw-mu__status--detail').text(_this.data.statusLabel);
  }
}

